export default __webpack_public_path__ + "static/media/img8.bc53b370.jpg";